(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-progress"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.BundleProgressRefresh) return;

  const SELECTOR = '[data-bundle-progress]';

  const bundleProgressRefresh = () => {
    const widget = document.querySelector(SELECTOR);
    if (!widget) return;
    const sectionEl = widget.closest('.shopify-section');
    if (!sectionEl) return;
    const sectionId = sectionEl.id.replace(/^shopify-section-/, '');
    const url = `${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        const html = data[sectionId];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector(SELECTOR);
        const current = document.querySelector(SELECTOR);
        if (!fresh || !current) return;
        current.style.minHeight = `${current.offsetHeight}px`;
        current.innerHTML = fresh.innerHTML;
        requestAnimationFrame(() => {
          current.style.minHeight = '';
        });
      })
      .catch(() => {});
  };

  window.BundleProgressRefresh = bundleProgressRefresh;
  document.addEventListener('cart:change', bundleProgressRefresh);
  document.addEventListener('cart:refresh', bundleProgressRefresh);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-reward-ladder"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.customElements.get('cart-reward-ladder')) return;

  class CartRewardLadder extends HTMLElement {
    connectedCallback() {
      this._onCartChanged = this._onCartChanged.bind(this);
      this._rate = Number(window.Shopify?.currency?.rate) || 1;
      this._thresholds = {
        standard: this._convertedThreshold('standard-threshold'),
        express: this._convertedThreshold('express-threshold'),
        gift: this._convertedThreshold('gift-threshold'),
      };
      // Rendered marker order is the ascending tier order; keep it the single source of truth.
      this._tiers = [...this.querySelectorAll('[data-reward-marker]')]
        .map((marker) => marker.dataset.rewardMarker)
        .filter((tier) => this._thresholds[tier] > 0);
      this._giftProductId = Number(this.getAttribute('gift-product-id')) || null;
      this._shippingTotal = this._numberAttribute('shipping-total') || 0;
      this._giftTotal = this._numberAttribute('gift-total') || 0;
      this._formatterWithoutDecimals = this._currencyFormatter(true);
      document.addEventListener('cart:change', this._onCartChanged);
      this._render();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this._onCartChanged);
    }

    _currencyFormatter(withoutDecimals) {
      const options = {
        style: 'currency',
        currency: window.Shopify?.currency?.active || window.ShopifyAnalytics?.meta?.currency || 'AUD',
        currencyDisplay: 'narrowSymbol', // "$100", not "A$100"; the market already sets the currency
      };
      if (withoutDecimals) {
        options.minimumFractionDigits = 0;
        options.maximumFractionDigits = 0;
      }
      return new Intl.NumberFormat(window.Shopify?.locale || document.documentElement.lang || 'en', options);
    }

    _numberAttribute(name) {
      const value = Number(this.getAttribute(name));
      return Number.isFinite(value) ? value : null;
    }

    _convertedThreshold(name) {
      const baseValue = this._numberAttribute(name);
      return baseValue === null ? null : Math.round(baseValue * this._rate);
    }

    _tierTotal(tier) {
      return tier === 'gift' ? this._giftTotal : this._shippingTotal;
    }

    _onCartChanged(event) {
      const cart = event.detail?.cart;
      if (!cart || !Array.isArray(cart.items)) return;

      const cartDiscount = (cart.cart_level_discount_applications || []).reduce(
        (sum, discount) => sum + (discount.total_allocated_amount || 0),
        0
      );
      const shippableItems = cart.items.filter((item) => item.requires_shipping);
      this._shippingTotal = Math.max(
        shippableItems.reduce((sum, item) => sum + item.final_line_price, 0) - cartDiscount,
        0
      );
      this._giftTotal = Math.max(
        shippableItems
          .filter((item) => !this._giftProductId || item.product_id !== this._giftProductId)
          .reduce((sum, item) => sum + item.final_line_price, 0) - cartDiscount,
        0
      );
      this._render();
    }

    _render() {
      if (this._tiers.length < 2) return;

      const nextIndex = this._tiers.findIndex((tier) => this._tierTotal(tier) < this._thresholds[tier]);
      const lastTier = this._tiers[this._tiers.length - 1];
      const state = nextIndex === -1 ? lastTier : nextIndex === 0 ? 'initial' : this._tiers[nextIndex - 1];

      this.dataset.rewardState = state;
      this.style.setProperty('--reward-progress', this._progressValue(nextIndex));
      this._tiers.forEach((tier, index) => {
        this._setTierState(tier, nextIndex === -1 || index < nextIndex, index === nextIndex);
      });

      const messageElement = this.querySelector('[data-reward-message]');
      const trackElement = this.querySelector('[data-reward-track]');
      const message = this._messageForNextTier(nextIndex);
      if (messageElement) this._renderMessage(messageElement, message.template, message.remaining);
      if (trackElement) {
        const max = this._thresholds[lastTier];
        trackElement.setAttribute('aria-valuemax', String(max));
        trackElement.setAttribute('aria-valuenow', String(Math.min(this._tierTotal(lastTier), max)));
        trackElement.setAttribute('aria-valuetext', messageElement?.textContent?.trim() || '');
      }
    }

    _setTierState(tier, achieved, current) {
      const marker = this.querySelector(`[data-reward-marker="${tier}"]`);
      const label = this.querySelector(`[data-reward-label="${tier}"]`);
      [marker, label].forEach((element) => {
        if (!element) return;
        element.classList.toggle('is-achieved', achieved);
        element.classList.toggle('is-current', current);
      });
      if (label) {
        if (current) label.setAttribute('aria-current', 'step');
        else label.removeAttribute('aria-current');
      }
    }

    _messageForNextTier(nextIndex) {
      if (nextIndex === -1) {
        const lastTier = this._tiers[this._tiers.length - 1];
        return { template: this.getAttribute(`${lastTier}-reached-message`) || '', remaining: 0 };
      }
      const tier = this._tiers[nextIndex];
      return {
        template: this.getAttribute(`${tier}-unreached-message`) || '',
        remaining: Math.max(this._thresholds[tier] - this._tierTotal(tier), 0),
      };
    }

    _renderMessage(element, template, remaining) {
      const placeholder = /\{\{\s*remaining_amount\s*\}\}/i;
      const match = template.match(placeholder);
      if (!match) {
        element.textContent = template;
        return;
      }

      const position = match.index;
      const amount = document.createElement('span');
      amount.className = 'bold text-accent';
      amount.textContent = this._formatAmount(remaining);
      element.replaceChildren(
        document.createTextNode(template.slice(0, position)),
        amount,
        document.createTextNode(template.slice(position + match[0].length))
      );
    }

    _formatAmount(amountInCents) {
      const roundedAmountInCents = Math.ceil(Math.max(amountInCents, 0) / 100) * 100;
      return this._formatterWithoutDecimals.format(roundedAmountInCents / 100);
    }

    // Markers sit at (2i + 1) / 2n of the track; the fill interpolates between neighbours.
    _progressValue(nextIndex) {
      if (nextIndex === -1) return '1';
      const count = this._tiers.length;
      const markerPosition = (index) => (2 * index + 1) / (2 * count);
      const tier = this._tiers[nextIndex];
      const previousThreshold = nextIndex === 0 ? 0 : this._thresholds[this._tiers[nextIndex - 1]];
      const start = nextIndex === 0 ? 0 : markerPosition(nextIndex - 1);
      const span = this._thresholds[tier] - previousThreshold;
      const intervalProgress = span > 0
        ? Math.min(Math.max(this._tierTotal(tier) - previousThreshold, 0) / span, 1)
        : 1;
      return String(start + intervalProgress * (markerPosition(nextIndex) - start));
    }
  }

  window.customElements.define('cart-reward-ladder', CartRewardLadder);
})();
  } catch(e) { console.error(e); }
})();

})();
